import "./styles/kitchencomboCard.css";
import vegIcon from "../../Assets/Images/vegpngoutput.png"
import nonvegIcon from "../../Assets/Images/nomvegoutput.png"
import { IoTimerOutline } from "react-icons/io5";
import React, { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import moment from "moment";

const KitchenComboTicket = (props) => {

    const { startTime, selectDate, item, type, fromPage, buynow, quantity, isQuantityUpdating, onQuantityChange } = props;

    const { vendor_id } = useParams();
    const [data, setData] = useState(props.Data);
    const navigate = useNavigate();
    const [timeLeft, setTimeLeft] = useState(null);
    const [expiredStatus, setExpiredStatus] = useState(false);
    const location = useLocation()
    const [ticketStartTimeDate, setTicketStartTimeDate] = useState(null)
    const timerRef = useRef(null);


    const DEFAULT_IMAGE_URL = "https://pingle.s3.ap-south-1.amazonaws.com/uploads/kitchen/kitchen_products/FoodPlaceholderRect.png";
    const ticketQuantity = Number(quantity) || 1;
    const showQuantityEditor = fromPage == "reviewpay" && typeof onQuantityChange === "function";

    useEffect(() => {
        setData((prevData) => (prevData !== item ? item : prevData));
        const storedTime = localStorage.getItem("dateandtime");
        setTicketStartTimeDate(storedTime ? JSON.parse(storedTime) : null)
    }, [vendor_id, item]);


    const bookBeforeTimes = [
        { id: 1, value: 1 },
        { id: 2, value: 2 },
        { id: 3, value: 3 },
        { id: 4, value: 9 },
        { id: 5, value: 12 },
        { id: 6, value: 24 },
        { id: 7, value: 48 },

    ];

    // useEffect(() => {
    //     const checkIfExpired = () => {
    //         const now = moment(); // Get current time
    //         const bookBefore = item.book_before;
    //         let deadline = moment(bookBefore);

    //         setExpiredStatus(now.isAfter(deadline) ? true : false);
    //     };

    //     checkIfExpired();
    // }, [item]);


    // const getValueById = (id) => {
    //     const item = bookBeforeTimes.find((time) => time.id == id);
    //     return item ? item.value : 0;
    // };

    // const calculateTimeLeft = () => {
    //     const now = moment();
    //     const bookBeforeHours = getValueById(Number(item.book_before)) || 0;

    //     const startDateTime = moment(`${selectDate || ticketStartTimeDate?.selectDate} ${startTime || ticketStartTimeDate?.startTime}`, "D MMMM YYYY hA");


    //     if (!startDateTime.isValid()) {
    //         return;
    //     }

    //     const deadline = startDateTime.clone().subtract(bookBeforeHours, "hours");

    //     if (now.isAfter(deadline)) {
    //         setTimeLeft("Expired");
    //         return;
    //     }

    //     // ⏳ BEFORE START (optional UX)
    //     if (now.isBefore(deadline)) {
    //         const duration = moment.duration(deadline.diff(now));

    //         const days = Math.floor(duration.asDays());
    //         const hours = duration.hours();
    //         const minutes = duration.minutes();
    //         const seconds = duration.seconds();

    //         const timeString = [
    //             days > 0 ? `${days}d` : "",
    //             hours > 0 ? `${hours}h` : "",
    //             minutes > 0 ? `${minutes} min` : ""
    //         ]
    //             .filter(Boolean)
    //             .join(" ");

    //         setTimeLeft(timeString || "0s");
    //     }
    // };

    // useEffect(() => {
    //     calculateTimeLeft();

    //     timerRef.current = setInterval(() => {
    //         calculateTimeLeft();
    //     }, 1000);

    //     return () => {
    //         if (timerRef.current) clearInterval(timerRef.current);
    //     };
    // }, [item?.book_before, startTime, selectDate, ticketStartTimeDate]);

    useEffect(() => {
        const calculateTimeLeft = () => {
            const target = item?.bookBefore || item?.book_before || item?.book_before_datetime || item?.bookBeforeDate;
            if (!target) return;

            const now = moment(); // Get current time
            const bookBefore = moment(target);
            if (!bookBefore.isValid()) return;

            if (now.isAfter(bookBefore)) {
                setTimeLeft("Expired");
                if (timerRef.current) clearInterval(timerRef.current); // Stop countdown
                return;
            }

            // Calculate remaining time
            const duration = moment.duration(bookBefore.diff(now));
            const days = Math.floor(duration.asDays());
            const hours = duration.hours();
            const minutes = duration.minutes();
            const seconds = duration.seconds();

            // Build dynamic time string
            let timeString = "";

            if (days > 0) {
                timeString = `${days}d ${hours}h`;
            } else if (hours > 0) {
                timeString = `${hours}h ${minutes}m`;
            } else {
                timeString = `${minutes}m ${seconds}s`;
            }
            setTimeLeft(timeString);
        };
        calculateTimeLeft(); // Run immediately
        timerRef.current = setInterval(calculateTimeLeft, 1000); // Update every second
        return () => {
            if (timerRef.current) clearInterval(timerRef.current);
        }; // Cleanup on unmount
    }, [item?.bookBefore, item?.book_before, item?.book_before_datetime, item?.bookBeforeDate]);

    return (

        <div className={`kitchen-combo-ticket ${fromPage == "reviewpay" ? "kitchen-combo-ticket-reviewpay" : ""}`}>
            <div className="kitchen-combo-img-wrapper">
                <img src={item?.ticket_img ? `https://pingle.s3.ap-south-1.amazonaws.com/uploads/kitchen/kitchen_products/${item?.ticket_img}`
                    : DEFAULT_IMAGE_URL}
                    alt={item?.ticket_img} className="kitchen-combo-img" onError={(e) => (e.target.src = DEFAULT_IMAGE_URL)} />

                {fromPage?.toLowerCase() !== "orderpass" && timeLeft &&
                    <span className="timer-badge"> <IoTimerOutline size={18} /> {timeLeft} </span>
                }
            </div>

            <div className="kitchen-combo-content">
                <h3 className="kitchen-combo-title ">
                    <span className="kitchen-combo-text">
                        {item?.ticket_name}
                    </span>
                </h3>
                <div className="kitchen-combo-price-row">
                    <div className="kitchen-combo-price-wrap">
                        <img src={item?.ticket_food_type == "1" ? vegIcon : nonvegIcon} alt={item?.ticket_food_type} className="kitchen-food-icon" />
                        <p className="kitchen-combo-price">
                            {item?.discount ? <span style={{ textDecoration: 'line-through', color: '#8a8a8a', fontSize: 12, marginRight: 6 }}><span className="rupeeIcon">₹</span>{item?.ticket_price}</span> : null}
                            <span className="rupeeIcon">₹</span>{item?.discount ? item?.discount : item?.ticket_price}
                        </p>
                    </div>
                    {showQuantityEditor && (
                        <div className="kitchen-ticket-qty-selector">
                            <button
                                type="button"
                                className="kitchen-ticket-qty-btn"
                                disabled={isQuantityUpdating || ticketQuantity <= 1}
                                onClick={() => onQuantityChange("remove")}
                            >
                                -
                            </button>
                            <span className="kitchen-ticket-qty-value">{ticketQuantity}</span>
                            <button
                                type="button"
                                className="kitchen-ticket-qty-btn"
                                disabled={isQuantityUpdating}
                                onClick={() => onQuantityChange("add")}
                            >
                                +
                            </button>
                        </div>
                    )}
                </div>
                <p className="kitchen-combo-desc">{item.about} </p>
                {buynow == "true" &&
                    <button onClick={() => navigate(`/ticket/${item?.vendor_id}/${item?.ticket_id}`, { state: { select_date: item?.request_date, type: 2 } })}
                        className="kitchen-combo-btn">Buy Now</button>}
            </div>
        </div>
    );
};


export default KitchenComboTicket;
